import { Fragment } from "react";
import { Company } from "../../../core/models/company.model";
import { IconWebsite } from "../../../assets/svgs-index";
import CompanyEmailInfo from "./CompanyEmailInfo";
import CompanyWebsiteInfo from "./CompanyWebsiteInfo";

const CompanyWebLinkInfo = (props: { company: Company | undefined, darkMode?: boolean  }) => {
  const { company, darkMode } = props;

  if (!company?.website && !company?.email) {
    return <Fragment />;
  }

  return (
    <div className="company-info d-inline-flex">
      <div className={`info-icon me-2 ${darkMode ? 'dark-mode' : ''}`}>
        <img src={IconWebsite} alt="website-icon" />
      </div>

      <CompanyWebsiteInfo company={company} />
      <CompanyEmailInfo company={company} />
    </div>
  );
};

export default CompanyWebLinkInfo;
